import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const DownloadLoader = () => {
  useEffect(() => {
    document.body.classList.add('noscroll');

    return () => {
      document.body.classList.remove('noscroll');
    };
  }, []);

  const { t } = useTranslation();

  return (
    <div className="download-loader" role="dialog" aria-modal="true" aria-label="Downloading">
      <div className="download-loader__modal">
        <div className="loading-dots">
          <div className="loading-dots--dot"></div>
          <div className="loading-dots--dot"></div>
          <div className="loading-dots--dot"></div>
        </div>
        <div className="download-loader__text">{t("downloading")}</div>
      </div>
    </div>
  );
};

export default DownloadLoader;
